<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childAdd"  @submit="addChannelSubmit" :updateData="addChannelData"></UPDATE>
    <UPDATE  ref="childUpdate"  @submit="updateChannelSubmit" :updateData="updateChannelData"></UPDATE>
    <UPDATE  ref="childAddApp"  @submit="addChannelAppSubmit" :updateData="addChannelAppData"></UPDATE>
    <UPDATE  ref="childDeleteApp"  @submit="deleteChannelAppSubmit" :updateData="deleteChannelAppData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import URL from '@/views/mis/util/url'
  import Qs from 'qs'

  // Local variables
  const type = 16;
  let metaData = [];
  let channelKeyList = [];

  export default {
    name: 'channel',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        // console.log("Row Data: ", row);
        if(clickName =="delete"){
          this.$axios.get(URL.advertising.configDel+"?id="+row.channelID).then(res=> {
              if (res.code == 0) {
                  this.$message.success("Successfully Deleted.");
                  this.reRenderComponents();
              }
          });
        }else if (clickName == "update" ){
          // Change property name for binding
          let data = {
            id: row.channelID,
            key: row.channelKey,
            value: row.channelName
          }
          this.$refs.childUpdate.open(data);
        }else if(clickName == "addApp"){
          this.$refs.childAddApp.open({channel: row.channelID, channelKey: row.channelKey});
        }else if (clickName == "deleteApp"){
          let channelAppKeyList = [];
          row.channelApps.forEach(item => {
            channelAppKeyList.push({key: item.id, value: item.name});
          });
          // Re-render the update component
          this.$set(this.deleteChannelAppData,
          "cols",
          [
            { title: 'id', field: 'id', hidden: true },
            { title: window.$t("mis.advertising.channelAppName"), field: 'appId', optionList:channelAppKeyList, required: true, type: 2, isNumber: true},
          ])
          // Change property name from channelID to id
          let data = {
            id: row.channelID,
            ...row
          }
          this.$refs.childDeleteApp.open(data);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        // console.log("Form data: ", data);
        if("查询" == clickName || window.$t("common.search") == clickName){
            let params = (data.value) ? {value: data.value, type: type} : {type: type};
            this.$refs.childTable.defaultQueryData(params);
        }else if("新增渠道" == clickName || window.$t("mis.advertising.addChannel") == clickName){
            this.$refs.childAdd.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      addChannelSubmit(model){
        // console.log("Submit add channel data: ", model);
        this.dataRequest( URL.advertising.configSave,model,res => {
          if (res.code == 0){
            this.$refs.childAdd.close();
            this.$message.success("Successfully Added.");
            this.reRenderComponents();
          }else{
            this.$message.error(res.message);
          }
        })
      },
      updateChannelSubmit(model){
        // console.log("Submit update channel data: ", model);
        this.dataRequest(URL.advertising.configEdit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("Successfully Updated.");
            this.$refs.childTable.defaultQueryData({type:type});
          }else{
            this.$message.error(res.message);
          }
        })
      },
      addChannelAppSubmit(model){
        // console.log("Submit add channel app data: ", model);
        // // Get the channel key from the meta data
        // model.channel = metaData.filter(item => item.id === model.channel)[0].key;
        model = {channel: model.channelKey, name: model.name};
        this.dataRequest(URL.advertising.channelAppSave,model,res => {
          if (res.code == 0){
            this.$refs.childAddApp.close();
            this.$message.success("Successfully Added.");
            this.$refs.childTable.defaultQueryData({type:type});
          }else{
            this.$message.error(res.message);
          }
        })
      },
      deleteChannelAppSubmit(model){
        // console.log("Submit delete channel app data: ", model);
        this.$axios.get(URL.advertising.channelAppDel+"?id="+model.appId).then(res=> {
          if (res.code == 0) {
            this.$refs.childDeleteApp.close();
            this.$message.success("Successfully Deleted.");
            this.$refs.childTable.defaultQueryData({type:type});
          }else{
            this.$message.error(res.message);
          }
        });
      },
      dataRequest(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
        })
      },
      setChannelKeyList(){
        this.$axios.post(URL.advertising.configQuery, Qs.stringify({type: type})).then(res => {
          if (res.code == 0) {
              metaData = res.result.list ? res.result.list : res.result;
              // console.log("Meta Data: ", metaData);
              if (metaData) {
                channelKeyList = metaData.map(({id, value})=>({key: id, value: value}));
                // console.log("Channel List: ", channelKeyList);
                this.$set(this.addChannelAppData,
                "cols",
                [
                  { title: 'id', field: 'id', hidden: true },
                  { title: 'channelKey', field: 'channelKey', hidden: true},
                  { title: window.$t("mis.advertising.channelName"), field: 'channel', type:2, optionList:channelKeyList, required: true, isNumber: true, readonly: true},
                  { title: window.$t("mis.advertising.channelAppName"), field: 'name', required: true}
                ]);
              }
          }else{
            this.$message.error(res.message);
          }
      })},
      reRenderComponents(){
        // Re-render the table component
        this.$refs.childTable.defaultQueryData({type:type});
        // Re-render the channel key list
        // this.setChannelKeyList();
      }
    },
    data () {
      return {
        deleteIds:"",
        category:true,
        queryData:{},
        /*新增渠道*/
        addChannelData:{
            cols:[
              { title: 'id', field: 'id', hidden: true },
              { title: window.$t("mis.advertising.type"), field: 'type',data:type, hidden:true,required: true},
              { title: window.$t("mis.advertising.channelKey"), field: 'key',required: true},
              { title: window.$t("mis.advertising.channelName"), field: 'value',required: true},
            ]
        },
        /*更新渠道*/
        updateChannelData:{
            cols:[
              { title: 'id', field: 'id', hidden: true },
              { title: window.$t("mis.advertising.type"), field: 'type',data:type, hidden:true,required: true},
              { title: window.$t("mis.advertising.channelKey"), field: 'key', hidden: true},
              { title: window.$t("mis.advertising.channelName"), field: 'value',required: true},
            ]
        },
        addChannelAppData:{
            cols:[
              { title: 'id', field: 'id', hidden: true },
              { title: 'channelKey', field: 'channelKey', hidden: true},
              // { title: window.$t("mis.advertising.channelName"), field: 'channel', type:2, optionList:channelKeyList, required: true, isNumber: true, readonly: true},
              { title: window.$t("mis.advertising.channelAppName"), field: 'name', required: true}
            ]
        },
        deleteChannelAppData:{
          cols:[
            // { title: 'id', field: 'id', hidden: true },
            // { title: window.$t("mis.advertising.channelAppName"), field: 'appId', optionList:channelAppKeyList, required: true, type: 2, isNumber: true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                {title:window.$t("mis.advertising.channelName"),field:'value',auth:"sys:advertisingChannel:query"},
                {click:window.$t("common.search"),auth:"sys:advertisingChannel:query"},
                {click:window.$t("mis.advertising.addChannel"),auth:"sys:advertisingChannel:save"},
                // {click:window.$t("mis.advertising.addChannelApp"),auth:"sys:advertisingChannelApp:save"},
          ]
        },
        /*table生成*/
        pageData: {
          // queryUrl: URL.advertising.configQuery, //请求路径和参数
          queryUrl: URL.advertising.channelAppGetData,
          // selection: true,
          sequence: true,
          cols: [
            { title: window.$t("mis.advertising.channelKey"), field: 'channelKey'},
            { title: window.$t("mis.advertising.channelName"), field: 'channelName'},
            { title: window.$t("mis.advertising.channelApp"), field: 'channelApps', render:(row, data)=>{
              if(row.length > 0) {
                return row.map(item => item.name).reduce((pre, cur) => pre + ", " + cur);
              } else {
                return "";
              } 
            }},
            { title: window.$t("mis.advertising.createTime"), field: 'createDate'},
            {title:window.$t("common.handle"),btnClick:[
              {name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:advertisingChannel:edit"},
              {name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:advertisingChannel:delete"},
              {name:window.$t("mis.advertising.addChannelApp"),click:"addApp",type:"primary",icon:"el-icon-circle-plus-outline",auth:"sys:advertisingChannelApp:save"},
              {name:window.$t("mis.advertising.deleteChannelApp"),click:"deleteApp",type:"primary",icon:"el-icon-delete",auth:"sys:advertisingChannelApp:delete", disabled:(row, data)=>{
                if (data.channelApps && data.channelApps.length > 0) {
                  return false;
                }else {
                  return true;
                }}
              }
            ]},
          ]
        }
      }
    },

    // created () {
    //     this.setChannelKeyList();
    // },
  }
</script>
